<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: ctaUrl = $recommendation.details?.brand.ctaUrl

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: ctaUrlText = $recommendation.details?.brand.ctaUrlText
</script>

<a class="header-url-button" href={ctaUrl}>
  {ctaUrlText}
</a>
